import React, { useState } from 'react';

const Addresses = () => {
  const [addresses, setAddresses] = useState([]);
  const [newAddress, setNewAddress] = useState('');
  const [editingIndex, setEditingIndex] = useState(null);
  const [editingAddress, setEditingAddress] = useState('');

  const handleAddAddress = () => {
    if (newAddress.trim()) {
      setAddresses([...addresses, newAddress]);
      setNewAddress('');
    }
  };

  const handleEditAddress = (index) => {
    setEditingIndex(index);
    setEditingAddress(addresses[index]);
  };

  const handleSaveEdit = () => {
    const updatedAddresses = [...addresses];
    updatedAddresses[editingIndex] = editingAddress;
    setAddresses(updatedAddresses);
    setEditingIndex(null);
    setEditingAddress('');
  };

  const handleDeleteAddress = (index) => {
    const updatedAddresses = addresses.filter((_, i) => i !== index);
    setAddresses(updatedAddresses);
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1>My Addresses</h1>

      {/* Add Address */}
      <div style={{ marginBottom: '20px' }}>
        <input
          type="text"
          placeholder="Enter new address"
          value={newAddress}
          onChange={(e) => setNewAddress(e.target.value)}
          style={{
            padding: '10px',
            width: '300px',
            marginRight: '10px',
            borderRadius: '5px',
            border: '1px solid #ccc',
          }}
        />
        <button
          onClick={handleAddAddress}
          style={{
            padding: '10px 20px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
          }}
        >
          Add Address
        </button>
      </div>

      {/* Address List */}
      <ul style={{ listStyleType: 'none', padding: 0 }}>
        {addresses.map((address, index) => (
          <li
            key={index}
            style={{
              marginBottom: '10px',
              padding: '10px',
              border: '1px solid #ccc',
              borderRadius: '5px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            {editingIndex === index ? (
              <div style={{ flex: 1, marginRight: '10px' }}>
                <input
                  type="text"
                  value={editingAddress}
                  onChange={(e) => setEditingAddress(e.target.value)}
                  style={{
                    padding: '10px',
                    width: '100%',
                    borderRadius: '5px',
                    border: '1px solid #ccc',
                  }}
                />
              </div>
            ) : (
              <span style={{ flex: 1 }}>{address}</span>
            )}

            {editingIndex === index ? (
              <button
                onClick={handleSaveEdit}
                style={{
                  padding: '5px 10px',
                  backgroundColor: '#28a745',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  marginRight: '5px',
                }}
              >
                Save
              </button>
            ) : (
              <button
                onClick={() => handleEditAddress(index)}
                style={{
                  padding: '5px 10px',
                  backgroundColor: '#ffc107',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  marginRight: '5px',
                }}
              >
                Edit
              </button>
            )}

            <button
              onClick={() => handleDeleteAddress(index)}
              style={{
                padding: '5px 10px',
                backgroundColor: '#dc3545',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
              }}
            >
              Delete
            </button>
          </li>
        ))}
      </ul>

      {/* No Addresses Message */}
      {addresses.length === 0 && <p>No addresses added yet.</p>}
    </div>
  );
};

export default Addresses;